module.exports = {"340111001":"骆岗街道","340111002":"常青街道","340111003":"芜湖路街道","340111004":"包公街道","340111005":"望湖街道","340111006":"义城街道","340111007":"烟墩街道","340111008":"滨湖世纪社区","340111009":"方兴社区","340111010":"万年埠街道","340111100":"淝河镇","340111102":"大圩镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340111.json
// module id = 1038
// module chunks = 0